<template>
  <donut-chart08-template
    :board-ids="[292, 293, 597, 396, 586, 607]"
    :data-type="dataType"
    :graph-id="88"
    title="근골격계 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart88',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
